export const users = [
    { username: "ByCalis", password: "fatclan" },
    { username: "FAT", password: "fatclan" },
    { username: "Porice", password: "fatclan" },
    { username: "Pedoman", password: "fatclan" },
    { username: "Umi023", password: "fatclan" },
    { username: "LoserChamp", password: "fatclan" },
    { username: "Rainduck", password: "fatclan" },
    { username: "Amogus", password: "fatclan" },
    { username: "Marjoe", password: "fatclan" },
  ];